module.exports = __webpack_public_path__ + "media/images/logo-small-15acd625aed406ca4c47c6e47f3427c8.png";